import axios from "axios"

export const getStockData = async () => {
    try {
        const response = await axios.get(`${process.env.VUE_APP_STOCK_ENDPOINT}`, {
            headers: {
                'Authorization': `Bearer ${process.env.VUE_APP_API_KEY}`, // Common for OAuth APIs
                'x-api-key': process.env.VUE_APP_API_KEY // Some APIs use custom headers
            }
        })
        const dataArray = Object.values(response.data)
        return {status: response.status, data: dataArray}
    } catch (error) {
        throw (error)
    }
}